var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "h2" }, [_vm._v(_vm._s(_vm.routeName))])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 offset-md-4 text-right center" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-primary",
                attrs: { to: "/admin/user-accounts", role: "button" }
              },
              [_vm._v("\n                    back\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.userRef
        ? _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.update.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "row justify-content-md-center" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-3" }, [
                      _vm._v(
                        "\n                Name: " +
                          _vm._s(_vm.userRef.firstName) +
                          " " +
                          _vm._s(_vm.userRef.lastName) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-3" }, [
                      _vm._v(
                        "\n                Email: " +
                          _vm._s(_vm.userRef.email) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.userRef.comments
                      ? _c("div", { staticClass: "col-3" }, [
                          _vm._v(
                            "\n                Current Gift Code: " +
                              _vm._s(_vm.userRef.comments) +
                              "\n              "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.corps.length
                      ? _c(
                          "div",
                          { staticClass: "col-3" },
                          [
                            _c("fg-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.rules.corporationId,
                                  expression: "rules.corporationId"
                                }
                              ],
                              attrs: {
                                label: "Select Gift Code",
                                list: _vm.corps,
                                selectedKey: "id",
                                "data-vv-name": "Corproration",
                                "cus-name": "Corporation",
                                "has-errors": _vm.errors,
                                "is-fields": _vm.fields
                              },
                              model: {
                                value: _vm.corporationId,
                                callback: function($$v) {
                                  _vm.corporationId = $$v
                                },
                                expression: "corporationId"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-fill btn-block",
                      attrs: {
                        type: "submit",
                        disabled: _vm.corporationId === 0
                      }
                    },
                    [
                      _vm._v(
                        "\n              Update User Association\n            "
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" })
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc585f48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc585f48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/EditUserAccount.vue
// module id = WYR6
// module chunks = 0